<div class="b-b b-col-42">
    <div class="flex flex-justify-between flex-middle p-t-5 p-b-5 p-t-4-m p-t-4-s p-b-4-m p-b-4-s cursor-pointer"
         [zippyToggle]="zippyId">
        <h5 class="o1">{{expandableTitle}}</h5>
        <i class="icon-plus fs-8 fs-9-m fs-9-s col-43"
           [zippyClass]="'!icon-plus icon-minus'"
           [zippyName]="zippyId"></i>
    </div>

    <div [zippyHideUp]="zippyId"
         [zippyState]="!!openAtStart"
         [zippyAnimationDuration]="750">
        <div class="p1 p-b-6 p-b-12-m p-b-12-s">
            <ng-content></ng-content>
        </div>
    </div>
</div>
